import React, { useState, useEffect } from 'react';
import Header from './components/Header';
import HomePage from './pages/HomePage';
import ToolPage from './pages/ToolPage';
import { diffTools } from './config/diff-tools';
import './App.css';

export default function App() {
  const [theme, setTheme] = useState(() => {
    const saved = localStorage.getItem('theme');
    return saved || 'dark';
  });

  const [currentRoute, setCurrentRoute] = useState(window.location.hash.slice(1) || '/');

  // Apply theme
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);
  }, [theme]);

  // Handle hash routing
  useEffect(() => {
    const handleHashChange = () => {
      setCurrentRoute(window.location.hash.slice(1) || '/');
    };

    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  // Update document title based on route
  useEffect(() => {
    if (currentRoute === '/') {
      document.title = 'DiffTools.net - Free Online Diff Tools for Developers';
    } else {
      const slug = currentRoute.replace('/', '');
      const tool = diffTools.find(t => t.slug === slug);
      if (tool) {
        document.title = `${tool.keyword} - Free ${tool.format.toUpperCase()} Comparison Tool | DiffTools.net`;
      }
    }
  }, [currentRoute]);

  const handleThemeToggle = () => {
    setTheme(prev => prev === 'light' ? 'dark' : 'light');
  };

  // Route to appropriate page
  const renderPage = () => {
    if (currentRoute === '/') {
      return <HomePage />;
    }

    const slug = currentRoute.replace('/', '');
    const tool = diffTools.find(t => t.slug === slug);

    if (tool) {
      return <ToolPage tool={tool} />;
    }

    // 404 - redirect to home
    return (
      <div style={{ textAlign: 'center', padding: '4rem 1rem' }}>
        <h1>Page Not Found</h1>
        <p>The tool you're looking for doesn't exist.</p>
        <a href="#/" style={{ color: 'var(--accent-color)' }}>← Back to Home</a>
      </div>
    );
  };

  return (
    <div className="app">
      <Header theme={theme} onThemeToggle={handleThemeToggle} />
      <main className="app-main">
        {renderPage()}
      </main>
      <footer className="app-footer">
        <p>
          DiffTools.net · Client-side only · No data stored or transmitted
        </p>
      </footer>
    </div>
  );
}
